import { zeroAddress } from "viem";
export const forma = {
    id: 984122,
    name: "Forma",
    network: "forma",
    nativeCurrency: {
        symbol: "TIA",
        name: "TIA",
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ["https://rpc.forma.art"],
            webSocket: ["wss://rpc.forma.art"],
        },
        public: {
            http: ["https://rpc.forma.art"],
            webSocket: ["wss://rpc.forma.art"],
        },
    },
    blockExplorers: {
        default: {
            name: "Forma Explorer",
            url: "https://explorer.forma.art",
        },
    },
    contracts: {
        multicall3: {
            address: "0xC5402e0BAF74c1042D72749cB8cA78c58dD93D6f",
            blockCreated: 1289867,
        },
    },
};
export const scroll = {
    id: 534352,
    name: "Scroll",
    network: "scroll",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: {
        default: {
            http: ["https://rpc.scroll.io"],
            webSocket: ["wss://wss-rpc.scroll.io/ws"],
        },
        public: {
            http: ["https://rpc.scroll.io"],
            webSocket: ["wss://wss-rpc.scroll.io/ws"],
        },
    },
    blockExplorers: {
        default: {
            name: "Scrollscan",
            url: "https://scrollscan.com",
        },
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14,
        },
    },
};
export const shape = {
    id: 360,
    name: "Shape",
    network: "shape",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: {
        default: {
            http: ["https://mainnet.shape.network"],
            webSocket: ["wss://wss-rpc.scroll.io/ws"],
        },
        public: {
            http: ["https://mainnet.shape.network"],
            webSocket: ["wss://wss-rpc.scroll.io/ws"],
        },
    },
    blockExplorers: {
        default: {
            name: "Shapescan",
            url: "https://shapescan.xyz",
        },
    },
    contracts: {
        multicall3: {
            address: "0xAA45a6e4e1E6e43c14B366Dd0228874fb1DC0eF9",
            blockCreated: 14,
        },
    },
};
export const formaReservoirChain = {
    id: 984122,
    name: "Forma",
    baseApiUrl: "https://api-forma.reservoir.tools",
    paymentTokens: [
        {
            chainId: 984122,
            address: zeroAddress,
            symbol: "TIA",
            name: "TIA",
            decimals: 18,
        },
        {
            chainId: 984122,
            address: "0xd5eace1274dbf70960714f513db207433615a263",
            symbol: "WTIA",
            name: "WTIA",
            decimals: 18,
        },
    ],
    checkPollingInterval: 1000,
};
export const shapeReservoirChain = {
    id: 360,
    name: "Shape",
    baseApiUrl: "https://api-shape.reservoir.tools",
    paymentTokens: [
        {
            chainId: 360,
            address: zeroAddress,
            symbol: "ETH",
            name: "ETH",
            decimals: 18,
        },
        {
            chainId: 360,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18,
        },
    ],
    checkPollingInterval: 1000,
};
